import React from "react";

export default function Icon03() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="#FEF8E6" />
      <g clipPath="url(#clip0_134_46761)">
        <path
          d="M23.3333 22V20.6667C23.3329 20.0758 23.1362 19.5019 22.7742 19.0349C22.4123 18.5679 21.9054 18.2344 21.3333 18.0867"
          stroke="#D3A812"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.3333 22V20.6667C19.3333 19.9594 19.0524 19.2811 18.5523 18.781C18.0522 18.281 17.3739 18 16.6667 18H11.3333C10.6261 18 9.94782 18.281 9.44772 18.781C8.94762 19.2811 8.66667 19.9594 8.66667 20.6667V22"
          stroke="#D3A812"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.6667 10.0867C19.2403 10.2335 19.7487 10.5671 20.1118 11.0349C20.4748 11.5026 20.6719 12.0779 20.6719 12.67C20.6719 13.2621 20.4748 13.8374 20.1118 14.3051C19.7487 14.7729 19.2403 15.1065 18.6667 15.2533"
          stroke="#D3A812"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 15.3333C15.4728 15.3333 16.6667 14.1394 16.6667 12.6667C16.6667 11.1939 15.4728 10 14 10C12.5272 10 11.3333 11.1939 11.3333 12.6667C11.3333 14.1394 12.5272 15.3333 14 15.3333Z"
          stroke="#D3A812"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_134_46761">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
